const i18next = require('i18next');

/**
 * Creates a fresh i18next instance loaded with a single language's translations.
 * Used by both gatsby-ssr.js (SSR) and gatsby-browser.js (client hydration) to ensure
 * only one language's translations are loaded per page.
 *
 * @param {string} lang - Language code (e.g., 'en', 'de', 'pt-br')
 * @param {object} translations - Full language object: { translation: { common: {...}, header: {...}, ... } }
 * @returns {import('i18next').i18n} Configured i18next instance
 */
function createI18nInstance(lang, translations) {
  const i18nLang = lang === 'pt-br' ? 'ptbr' : lang;
  const i18n = i18next.createInstance();
  i18n.init({
    resources: {
      [i18nLang]: translations
    },
    lng: i18nLang,
    fallbackLng: i18nLang,
    interpolation: { escapeValue: false },
    initImmediate: false,
  });
  return i18n;
}

module.exports = { createI18nInstance };
